var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-tabs',[_c('rkm-tab',{attrs:{"active":"","title":"Enviadas"}},[_c('Enviada')],1),_c('rkm-tab',{attrs:{"title":"Recebidas"}},[_c('Recebida')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }